import { connect } from 'react-redux';

import { getScoringHistoryAction } from '../../actions/dashboardActions';
import {
  getLoadingScoringHistory,
  getScoringHistorySelector,
} from '../../components/Dashboard/dashboardSelectors';
import ScoringHistory from '../../components/Dashboard/ScoringHistory/scoringHistory.jsx';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  scoringHistory: getScoringHistorySelector(state),
  userCreatedAt: getUser(state).createdAt,
  loading: getLoadingScoringHistory(state),
});
const mapDispatchToProps = (dispatch) => ({
  loadScoringHistory: (timePeriod) => {
    dispatch(getScoringHistoryAction(timePeriod));
  },
});

const ScoringHistoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScoringHistory);

export default ScoringHistoryContainer;
